import script from "./ComingSoonDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ComingSoonDialog.vue?vue&type=script&setup=true&lang=js"

import "./ComingSoonDialog.vue?vue&type=style&index=0&id=b7907dba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7907dba"]])

export default __exports__